export default __webpack_public_path__ + "static/media/HeaderArrow.524efc0c.svg";